import {ColumnProps} from "@vebox/etui-core";
import * as React from "react";

export interface CurrentConfigurationData {
    info: string | React.ReactNode,
    label: string | React.ReactNode,
    name: string | React.ReactNode,
    // unitOfMeasure: string,
    default: string,
    min: string,
    max: string,
    current: string | React.ReactNode,
    lastUpdate: string,
}


export enum TABLES_NAMES {
    INFO = "",
    LABEL = "Label",
    NAME = "Name",
    DEFAULT = "Default",
    MIN = "Min",
    MAX = "Max",
    CURRENT = "Current",
    NEW = "New",
    LAST_UPDATE = "Last Update",
    READ = "Read",
    STATUS = "Status",
}


export enum TABLES_INDEXES {
    INFO = 'info',
    LABEL = 'label',
    NAME = 'name',
    UNIT_OF_MEASURE = 'unitOfMeasure',
    DEFAULT = 'default',
    MIN = 'min',
    MAX = 'max',
    CURRENT = 'current',
    NEW = 'new',
    LAST_UPDATE = 'lastUpdate',
    READ = 'read',
    STATUS = 'status',
}

export interface TableColumn extends ColumnProps<any> {
    title: React.ReactNode,
    dataIndex: string,
    key: string,
}

export interface groupedMappedCurrentSettings {
    [key: string]: CurrentConfigurationData[]
}